<template>
  <div class="wrap">
    <!-- 服务协议详情 -->
    <template v-for="(item, index) in datas" :key="index">
      <div class="itemBox">
        <h3 v-if="item.title" class="itemTitle">{{ item.title }}</h3>
        <template v-for="(p, pIndex) in item.word" :key="pIndex">
          <div v-if="p.content" class="pItem">
            <span>{{ p.empty }}</span>
            <span v-if="p.dot" class="dot">●</span>
            <span v-html="p.content"></span>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue'

export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const state = reactive({
      datas
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.wrap {
  padding-bottom: calc(6px + constant(safe-area-inset-bottom));
  padding-bottom: calc(6px + env(safe-area-inset-bottom));
  text-align: left;
  color: #333;
  font-size: 12px;
}
.itemBox {
  margin: 0 0 16px;
}
.itemTitle {
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 14px;
}
/* .itemTitle::after {
  display: block;
  margin: 6px 0;
  content: '';
  height: 2px;
  background-color: #333;
} */
.dot {
  display: inline-block;
  margin: 0 5px 2px 0;
  vertical-align: middle;
}
.pItem {
  line-height: 20px;
  vertical-align: middle;
}
</style>
